import { t } from "i18next";
import { z } from "zod";

export const ForgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, t("schemas.forgotPassword.email.min"))
    .email(t("schemas.forgotPassword.email.email")),
});

export type ForgotPasswordSchemaType = z.infer<typeof ForgotPasswordSchema>;
